export const TodEvents = {
  DATE_SELECT: 'date',
  SCHEDULE_SELECT: 'schedule',
  LANGUAGE: 'language',
  MESSAGE_FOR_TUTOR: 'message_for_tutor',
  CHECKOUT: 'checkout',
  LOCATION: 'location',
  PHYSICAL_LOCATION: 'physical_location',
  PRODUCT_SELECT: 'product',
  LEVELS_OF_EDUCATION: 'levels_of_education',
  SUBJECT_SELECT: 'subject',

  FORM: {
    SUBMIT: 'form:save',
    SET_FIELD: 'form:set-field',
  },
  PAYMENT: {
    SET_COUPON_CODE: 'set_coupon_code',
    SET_CARD_INFO: 'set_card_info',
    APPLIED_COUPON_CODE: 'applied_coupon_code',
    PAID_AMOUNT: 'paid_amount',
    PAYMENT_FAILED: 'payment_failed',
  },
  INITIATED: 'initiated',
  CAMPAIGN: {
    CLICK_PRODUCT: 'campaign:click_product',
    GO_TO_CHECKOUT: 'campaign:go_to_checkout',
  },
}

export enum TodButtonEventName {
  CHAT_WITH_TUTOR = 'chat_with_tutor',
  VIDEO_CHAT_CHECKOUT = 'video_chat_checkout',
  BOOK_A_TUTOR_FOR_SELF_CHECKOUT = 'book_a_tutor_for_self_checkout',
  APPLY_COUPON = 'apply_coupon',
  BOOKING_BUTTON = 'booking_button',
  CONFIRM_PAYMENT = 'confirm_payment',
}
